import React from 'react';
// nodejs library that concatenates classes

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import makeStyles from '@mui/styles/makeStyles';

import officeStyle from 'assets/jss/nextjs-material-kit-pro/pages/aboutUsSections/officeStyle.js';

const useStyles = makeStyles(officeStyle);

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const CarouselComponent = ({images})=>(
    <Carousel
        additionalTransfrom={0}
        swipeable={true}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        keyBoardControl={true}
        containerClass="carousel-container"
        dotListClass=""
        arrows={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
    >
        {images.map((image,index)=>(
            <div style={{
                backgroundImage:`url(${image})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height:'200px',
                width: '95%'
            }} key={index}/>
        ))}

    </Carousel>
);


export default function SectionOffice() {
    const classes = useStyles();
    return (
        <div className={classes.office}>
            <a className={classes.anchor} id='sponsors'  />
            <h2 className={classes.title}>The Sponsors</h2>
            <h4 className={classes.description}>
            Here are our valuable sponsors in the project that makes all these possible.
            </h4>

            <h4 className={classes.title}>Major Industry Sponsors</h4>
            <CarouselComponent images={[
                // require('assets/img/sponsors/Goldfields.png'), change this to Agincourt Resources
                require('assets/img/sponsors/Goldfields.png'),

            ]} />
            <h4 className={classes.title}>Minor Industry Sponsors</h4>
            <CarouselComponent images={[
                require('assets/img/sponsors/lundin-mining.png'),
                // require('assets/img/sponsors/lundin-mining.png'), change this to Rio Tinto
                // require('assets/img/sponsors/lundin-mining.png'), change this to Independence Group
                // require('assets/img/sponsors/lundin-mining.png'), change this to CMOC
                require('assets/img/sponsors/bhp.jpg'),
                // require('assets/img/sponsors/lundin-mining.png'), change this to Anglo American
                // require('assets/img/sponsors/lundin-mining.png'), change this to LKAB
            ]} />
            <h4 className={classes.title}>Technology Sponsors</h4>
            <CarouselComponent images={[
                require('assets/img/sponsors/3vG.png'),
                require('assets/img/sponsors/groundprobe.png'),
                require('assets/img/sponsors/institute-of-mine-seismology.png'),
                // require('assets/img/sponsors/institute-of-mine-seismology.png'), change this to CGG Services UK
                // require('assets/img/sponsors/institute-of-mine-seismology.png'), change this to Multi-physics Imaging
                require('assets/img/sponsors/sercel.jpg'),
                require('assets/img/sponsors/Canary.png'),

            ]} />
        </div>
    );
}
